import React from "react";
import { FormControl } from "@mui/material";
import { Control, UseFormRegister, FormState } from "react-hook-form";
import { CreateCasesFormInput } from "./CreateTicketDialog";
import { CreateTicketTitleField } from "./CreateTicketTitleField";
import { CreateTicketNotesField } from "./CreateTicketNotesField";

type CreateCaseModalProps = {
  hasCreateCasePermissions: boolean;
  register: UseFormRegister<CreateCasesFormInput>;
  formState: FormState<CreateCasesFormInput>;
};

export const CreateTicketWebhookDialog = ({
  hasCreateCasePermissions,
  register,
  formState,
}: CreateCaseModalProps) => {
  return (
    <>
      <FormControl fullWidth>
        <CreateTicketTitleField
          textFieldProps={register("webhook.title", { required: true })}
          errorMessage={formState.errors?.webhook?.title?.message}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mt: 3 }}>
        <CreateTicketNotesField
          textFieldProps={register("webhook.notes")}
          errorMessage={formState.errors?.webhook?.notes?.message}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>
    </>
  );
};
